import { Component, OnInit, Injector } from '@angular/core';
import { take } from 'rxjs';
import { Utils } from '../../../../shared/Utils/Utils';
import { BaseSWQuestion } from '../../../extended-class/base-ws-question';
import { LookUpResourceModel } from '../../../models/lookup-resource.model';
import { TelephoneMaskPipe } from '../../../../shared/pipe/mask-pipe';

@Component({
  selector: '[phone]',
  templateUrl: './phone.component.html'
})
export class PhoneComponent extends BaseSWQuestion implements OnInit {
  public question: LookUpResourceModel;
  public isValid = true;
  public isTeleDataModified = false;

  constructor(serviceInjector: Injector) {
    super(serviceInjector);
  }
  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((param: any) => {
      this.question = JSON.parse(param['question']);
    });

    this.swProcessStateService.swContractType$.pipe(take(1)).subscribe((contractType) => {
      this.contractType = JSON.parse(JSON.stringify(contractType));
    });
  }
  public onTeleModelChange(modelData: string) {
    this.isTeleDataModified = true;
    this.contractType.phone = modelData;
  }
  public onTeleFocusField() {
    if (!this.isTeleDataModified) {
      this.contractType.phone = '';
    }
  }
  public applyTeleMask(): string {
    if (!this.isTeleDataModified && this.contractType?.phone) {
      const telePipe = new TelephoneMaskPipe();
      return telePipe.transform(this.contractType.phone);
    } else {
      return this.contractType?.phone;
    }
  }
  saveSectionAnswer() {
    if (this.validationUiService.isValidTelephone(this.contractType?.phone)) {
      this.isValid = true;
      this.addGTMAnswer(this.question.QuestionNumber, this.contractType.phone);
      this.swProcessStateService.updateSwProcessModel(this.contractType);
      this.sectionWiseService.closeSwqModal(this.question);
    } else {
      this.isValid = false;
      this.gtmDatalayerUiService.addVirtualPageValidationError('Q7', 2, 'Por favor, introduce un número de teléfono válido').toPromise();
    }
  }

  onKeyPress(evt: any) {
    return Utils.isNumber(evt);
  }
}
